import { Link, LinkProps } from '@tanstack/react-router';
import * as React from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';

export interface BreadcrumbItemProps {
  label: string;
  link: LinkProps;
}

interface AdminPageHeaderProps {
  breadcrumbItems: BreadcrumbItemProps[];
  center?: React.ReactNode;
  right?: React.ReactNode;
}

export function AdminPageHeader({
  breadcrumbItems,
  center,
  right,
}: AdminPageHeaderProps) {
  return (
    <header className="sticky top-0 z-10 flex h-16 shrink-0 rounded-t-xl items-center gap-2 border-b bg-background px-4 backdrop-blur-sm">
      <div className="flex flex-1 items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbItems.map((item, index) => (
              <React.Fragment key={item.label}>
                <BreadcrumbItem>
                  {index === breadcrumbItems.length - 1 ? (
                    <BreadcrumbPage>{item.label}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link
                        to={item.link.to}
                        params={item.link.params}
                        search={item.link.search}
                      >
                        {item.label}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {index < breadcrumbItems.length - 1 && <BreadcrumbSeparator />}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      {center && (
        <div className="flex flex-1 items-center justify-center">{center}</div>
      )}
      {right && (
        <div className="flex flex-1 items-center justify-end gap-2">
          {right}
        </div>
      )}
    </header>
  );
}
